    $(".cstm-color-box").click(function () {
      $(this).siblings().removeClass("cstm-active-box");
      $(this).addClass("cstm-active-box");
    });
      $(".cstm-color-box:first-child").addClass("cstm-active-box");


 jQuery('.cstm-color-box').click(function () {
  var d_val = jQuery(this).attr('data-option-value-id');
  jQuery('input.product-variant-id').val(d_val);
});


$(document).ready(function () {
  var firstTab = $('.cstm-tab-btn:first');
  var selectedTab = firstTab.attr('data-tab');

  // Add active class to first tab
  firstTab.addClass('tab-active-btn');

  // Hide all content sections and show the first one
  $('.cstm-variant-body-item').hide();
  $('.cstm-variant-body-item[data-tab-content="' + selectedTab + '"]').show();

  // Handle tab clicking
  $('.cstm-tab-btn').click(function () {
    var selectedTab = $(this).attr('data-tab');

    // Remove active class from all buttons and add to clicked button
    $('.cstm-tab-btn').removeClass('tab-active-btn');
    $(this).addClass('tab-active-btn');

    // Hide all content sections
    $('.cstm-variant-body-item').hide();

    // Show the matching content
    $('.cstm-variant-body-item[data-tab-content="' + selectedTab + '"]').show();
  });
});


$(document).ready(function () {
  $('.header__searchButton').click(function () {
    $('.header__logo').removeClass('fade-in')
    setTimeout(() => {
      $('.header__search').addClass('fade-in')
    }, 300)
  });
});